import Translations from "@translate/components/fitness/sharpen/chat-cards/SharpenConfirmCard";
/**
 * SharpenConfirmCard — Sharpen Chat 确认卡 (US7 S7.3)
 *
 * Figma: `97283:75306` · `97283:88506`
 * Interactive Tool: `confirm_sharpen_score`（Logic L7 接线）
 */

import { I18nUtil } from "@utils/i18n";
import { Icon } from "@ospweb/sdk-ui";
import { FitnessRadarChart } from "@/src/components/fitness/RadarChart/FitnessRadarChart";
import { buildOpenReplayLabel } from "@/src/utils/openreplay";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

/** 确认卡装饰雷达 — 生成前示意，非接口真实分数 */
const SHARPEN_CONFIRM_RADAR_SCORE = 72;

export interface SharpenConfirmCardProps {
  summary: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  onConfirm: () => void;
  className?: string;
}

export function SharpenConfirmCard({
  summary,
  disabled = false,
  isSubmitting = false,
  onConfirm,
  className,
}: SharpenConfirmCardProps) {
  const isCtaDisabled = disabled || isSubmitting;

  return (
    <div
      className={cn(
        "flex w-full items-start gap-4 overflow-clip rounded-3 border border-border_inverse_transparent10 bg-background_solid_neutral_primary p-4 md:max-w-[534px]",
        className,
      )}
      data-testid="sharpen-confirm-card"
      data-node-id="97283:75306"
    >
      <div className="flex min-w-0 flex-1 flex-col items-start gap-4">
        <div className="flex w-full flex-col items-start gap-1">
          <p className="title_l text-content_primary">
            {I18n.t("Generate your real Fitness Score?")}
          </p>
          <div className="flex w-full items-start gap-1.5 overflow-clip">
            <Icon
              name="check"
              size={16}
              className="shrink-0 text-content_brand_primary"
            />
            <p className="body_medium_s min-w-0 flex-1 text-content_primary">
              {summary}
            </p>
          </div>
          <p className="body_s w-full text-content_tertiary">
            {I18n.t("This replaces your quick-read with the real number.")}
          </p>
        </div>

        <button
          type="button"
          className={cn(
            "button md_button primary_button flex h-9 min-w-[80px] items-center justify-center gap-0.5 overflow-clip rounded-2 px-3 py-2",
            isCtaDisabled && "pointer-events-none opacity-50",
          )}
          data-testid="sharpen-confirm-cta"
          data-openreplay-label={buildOpenReplayLabel(
            "Fitness",
            "SharpenConfirm",
            "Click",
            "Generate my score",
          )}
          disabled={isCtaDisabled}
          onClick={onConfirm}
        >
          <span className="body_medium_m whitespace-nowrap text-content_inverse_primary">
            {I18n.t("Generate my score")}
          </span>
        </button>
      </div>

      <FitnessRadarChart
        total={SHARPEN_CONFIRM_RADAR_SCORE}
        control={SHARPEN_CONFIRM_RADAR_SCORE}
        safety={SHARPEN_CONFIRM_RADAR_SCORE}
        growth={SHARPEN_CONFIRM_RADAR_SCORE}
        size="compact"
      />
    </div>
  );
}
